<section class="about-unique dingo-section dingo-bg-accent">
  <div class="container">
    <div class="about-section-head section-head reveal-on-scroll" data-reveal="section-head">
      <p class="about-kicker">Lo que nos hace diferentes</p>
      <h2 class="about-section-title">
        No solo ejecutamos campañas. Construimos <span class="highlight-green">sistemas de crecimiento.</span>
      </h2>
      <p class="about-section-desc">
        Integramos estrategia, canales, contenido, automatización y tecnología para convertir objetivos comerciales en
        resultados reales.
      </p>
    </div>

    <div class="about-feature-grid">
      @for (stat of uniqueStats; track stat.title; let i = $index) {
      <article class="about-stat-card reveal-on-scroll" data-reveal="card" [style.--reveal-order]="i">
        <span class="about-stat-value">{{ stat.value }}</span>
        <h3 class="about-stat-title">{{ stat.title }}</h3>
        <p class="about-stat-desc">{{ stat.description }}</p>
      </article>
      }
      <aside class="about-method-card reveal-on-scroll" data-reveal="card" style="--reveal-order: 3">
        <span>Output</span>
        <strong>Plan accionable, reporting claro y optimización continua.</strong>
        <a class="dingo-cta-primary" routerLink="/contacto">
          Agendar diagnóstico
          <i class="bi bi-calendar-check"></i>
        </a>
      </aside>
    </div>
  </div>
</section>
